// extracted by mini-css-extract-plugin
export default {"adboxContainer":"styles_adboxContainer__Loq4h","adContent":"styles_adContent__UwQvl"};